export default "__VITE_ASSET__xC6cdHsZ__";